var map = {
	"./000_intro_part2.first.avif": 44,
	"./000_intro_part2.first.png": 45,
	"./000_intro_part2.first.webp": 46,
	"./000_intro_part2.last.avif": 47,
	"./000_intro_part2.last.png": 48,
	"./000_intro_part2.last.webp": 49,
	"./de/010_home.first.avif": 50,
	"./de/010_home.first.png": 51,
	"./de/010_home.first.webp": 52,
	"./de/080_finish_bad.first.avif": 53,
	"./de/080_finish_bad.first.png": 54,
	"./de/080_finish_bad.first.webp": 55,
	"./de/080_finish_bad.last.avif": 56,
	"./de/080_finish_bad.last.png": 57,
	"./de/080_finish_bad.last.webp": 58,
	"./de/080_finish_good.first.avif": 59,
	"./de/080_finish_good.first.png": 60,
	"./de/080_finish_good.first.webp": 61,
	"./de/080_finish_good.last.avif": 62,
	"./de/080_finish_good.last.png": 63,
	"./de/080_finish_good.last.webp": 64,
	"./de/080_finish_soso.first.avif": 65,
	"./de/080_finish_soso.first.png": 66,
	"./de/080_finish_soso.first.webp": 67,
	"./de/080_finish_soso.last.avif": 68,
	"./de/080_finish_soso.last.png": 69,
	"./de/080_finish_soso.last.webp": 70,
	"./en/010_home.first.avif": 71,
	"./en/010_home.first.png": 72,
	"./en/010_home.first.webp": 73,
	"./en/080_finish_bad.first.avif": 74,
	"./en/080_finish_bad.first.png": 75,
	"./en/080_finish_bad.first.webp": 76,
	"./en/080_finish_bad.last.avif": 77,
	"./en/080_finish_bad.last.png": 78,
	"./en/080_finish_bad.last.webp": 79,
	"./en/080_finish_good.first.avif": 80,
	"./en/080_finish_good.first.png": 81,
	"./en/080_finish_good.first.webp": 82,
	"./en/080_finish_good.last.avif": 83,
	"./en/080_finish_good.last.png": 84,
	"./en/080_finish_good.last.webp": 85,
	"./en/080_finish_soso.first.avif": 86,
	"./en/080_finish_soso.first.png": 87,
	"./en/080_finish_soso.first.webp": 88,
	"./en/080_finish_soso.last.avif": 89,
	"./en/080_finish_soso.last.png": 90,
	"./en/080_finish_soso.last.webp": 91,
	"./games/020_start.first.avif": 92,
	"./games/020_start.first.png": 93,
	"./games/020_start.first.webp": 94,
	"./games/020_start.last.avif": 95,
	"./games/020_start.last.png": 96,
	"./games/020_start.last.webp": 97,
	"./games/030_corner1.first.avif": 98,
	"./games/030_corner1.first.png": 99,
	"./games/030_corner1.first.webp": 100,
	"./games/030_corner1.last.avif": 101,
	"./games/030_corner1.last.png": 102,
	"./games/030_corner1.last.webp": 103,
	"./games/040_tunnel.first.avif": 104,
	"./games/040_tunnel.first.png": 105,
	"./games/040_tunnel.first.webp": 106,
	"./games/040_tunnel.last.avif": 107,
	"./games/040_tunnel.last.png": 108,
	"./games/040_tunnel.last.webp": 109,
	"./games/050_brake.first.avif": 110,
	"./games/050_brake.first.png": 111,
	"./games/050_brake.first.webp": 112,
	"./games/050_brake.last.avif": 113,
	"./games/050_brake.last.png": 114,
	"./games/050_brake.last.webp": 115,
	"./games/060_corner2.first.avif": 116,
	"./games/060_corner2.first.png": 117,
	"./games/060_corner2.first.webp": 118,
	"./games/060_corner2.last.avif": 119,
	"./games/060_corner2.last.png": 120,
	"./games/060_corner2.last.webp": 121,
	"./games/070_boost.first.avif": 122,
	"./games/070_boost.first.png": 123,
	"./games/070_boost.first.webp": 124,
	"./games/070_boost.last.avif": 125,
	"./games/070_boost.last.png": 126,
	"./games/070_boost.last.webp": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 298;